import axios from 'axios';

const getCoordinates = async zipCode => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?postalcode=${zipCode}&country=USA&format=json`
  );

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data = await response.json();

  if (data && data.length > 0) {
    const { lat, lon } = data[0];
    return { latitude: parseFloat(lat), longitude: parseFloat(lon) };
  } else {
    return null; // No location found
  }
};
// def get_route_distance(coord1, coord2, api_key):
//     # Google Maps Directions API endpoint
//     url = f"https://maps.googleapis.com/maps/api/directions/json?origin={coord1[0]},{coord1[1]}&destination={coord2[0]},{coord2[1]}&key={api_key}"

//     response = requests.get(url)
//     data = response.json()

//     if data['status'] == 'OK':
//         route_distance = data['routes'][0]['legs'][0]['distance']['value'] / 1609.34  # Convert meters to miles
//         return route_distance
//     else:
//         return None

const getDistance = async (ocord1, ocord2, dcord1, dcord2) => {
  const api_key = 'AIzaSyBZUlA6YY8998nbFVsE_VuXZ4JpQRJwgHY';
  // const response = await fetch(`https://maps.googleapis.com/maps/api/directions/json?origin=${ocord1},${ocord2}&destination=${dcord1},${dcord2}&key=${api_key}`);
  const response = await axios.get(
    `https://maps.googleapis.com/maps/api/directions/json?origin=${ocord1},${ocord2}&destination=${dcord1},${dcord2}&key=${api_key}`
  );

  // if (!response.ok) {
  //   throw new Error('Network response was not ok');
  // }

  // const data = await response.json();

  // if (data.status === 'OK') {
  const routeDistance =
    response.data.routes[0].legs[0].distance.value / 1609.34; // Convert meters to miles
  return routeDistance;
  // } else {
  //   return null; // Handle API error
  // }
};

export const calculateDistance = async (fromZip, toZip) => {
  try {
    const [cords1, cords2] = await Promise.all([
      getCoordinates(fromZip),
      getCoordinates(toZip)
    ]);

    if (!cords1 || !cords2) {
      throw new Error(
        'Could not retrieve coordinates for one or both zip codes'
      );
    }

    const distance = await getDistance(
      cords1.latitude,
      cords1.longitude,
      cords2.latitude,
      cords2.longitude
    );

    return distance;
  } catch (error) {
    console.error(error);
    return null; // Handle error case appropriately
  }
};

export function calculateRatePerMile(milesString, totalRate) {
  if (!milesString || !totalRate) return 0;

  // Extract number from string like "1,270 mi"
  const miles = parseFloat(milesString.replace(/[^\d.]/g, ''));

  if (!miles || miles === 0) return 0;

  const rate = totalRate / miles;
  return Number(rate.toFixed(2));
}
